import { PlantTimesheetReport } from "@interfaces/ITimesheetEmployeeRowDTO";
import axiosClient from "@service/axiosClient";

// mirrors the HTML form POST to /process_dates
export async function fetchPlantTimesheetReport(params: {
  plant_id: number;
  start_date: string; // YYYY-MM-DD
  end_date: string; // YYYY-MM-DD
}): Promise<PlantTimesheetReport> {
  // Backend likely expects form-encoded data (it used a form).
  const body = new URLSearchParams();
  body.set("plant_id", String(params.plant_id));
  body.set("start-date", params.start_date);
  body.set("end-date", params.end_date);

  const response = await axiosClient.post<PlantTimesheetReport>(
    "/plant_api/process_dates",
    body,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      maxRedirects: 0,
    }
  );

  return response.data;
}

// mirrors the old "Send Conf Emails" form POST
export async function sendConfirmEmails(payload: {
  plant_id: number;
  start_date: string; // YYYY-MM-DD
  end_date: string; // YYYY-MM-DD
}) {
  const body = new URLSearchParams();
  body.set("plant_id", String(payload.plant_id));
  body.set("start_date", payload.start_date);
  body.set("end_date", payload.end_date);

  const response = await axiosClient.post<{ status: string }>(
    "/new/hours/confirm",
    body,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      maxRedirects: 0,
    }
  );

  return response.data;
}
